import React, { ReactElement } from 'react';

import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { testId } from 'pricing/utilities/test/dataTestId';
import { AddContractTermBtn } from './AddContractTerm.style';

function AddContractTerm(): ReactElement {
  const { dispatch } = useContractState();

  const handleTermsFormVisible = () => {
    dispatch({
      type: 'SET_TERMS_FORM_VISIBLE',
      termsFormVisible: true,
    });
  };

  return (
    <AddContractTermBtn
      data-testid={testId.addContractTerm}
      className="ContractTermsAddBtn"
      type="dashed"
      block
      onClick={handleTermsFormVisible}
    >
      + Add Terms
    </AddContractTermBtn>
  );
}

export default AddContractTerm;
